var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import styles from './hidden.module.scss';
export var HiddenInput = function (_a) {
    var type = _a.type, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.required, required = _c === void 0 ? false : _c, input = _a.input, meta = _a.meta, updatedValue = _a.updatedValue, rest = __rest(_a, ["type", "disabled", "required", "input", "meta", "updatedValue"]);
    useEffect(function () {
        if (typeof updatedValue !== 'undefined') {
            input.onChange(updatedValue);
        }
    }, [updatedValue]);
    return (React.createElement("input", __assign({ type: type, disabled: disabled, required: required, className: styles.hiddenInput }, rest)));
};
//# sourceMappingURL=hidden.js.map